/*
 * argile-collection-shop.js — « Boutique collection ».
 * Add-to-cart AJAX pour les boutons `[data-shop-add][data-variant-id]` de la grille.
 * Ajoute la variante au panier (/cart/add avec sections rendues), rafraîchit l'UI
 * panier Horizon via `cart:update` (bubble + morph propre du tiroir, pas de re-fetch)
 * PUIS ouvre le tiroir une fois le morph + cross-sell terminés (event
 * `argile:recos-ready` ou timeout de secours). Recette identique à argile-product.js :
 * ouvrir AVANT la fin du morph annule l'ouverture, d'où l'ouverture différée.
 * Pendant tout ce délai, le bouton affiche un spinner (`is-loading`), retiré à
 * l'ouverture du tiroir → retour visuel immédiat, comme sur la fiche produit.
 * Listener global délégué → couvre l'éditeur.
 */
(() => {
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest && event.target.closest('[data-shop-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();

    const vid = btn.getAttribute('data-variant-id');
    if (!vid || btn.dataset.loading) return;
    btn.dataset.loading = '1';
    // Spinner immédiat : maintenu jusqu'à l'ouverture du tiroir (cf. openDrawer).
    btn.classList.add('is-loading');

    const addUrl =
      (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) ||
      '/cart/add';

    // Ids des sections cart-items → morph propre du tiroir (pas de re-fetch).
    const sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });

    // Ouvre le tiroir une seule fois, soit quand le cross-sell a fini de
    // (re)charger (`argile:recos-ready`), soit au timeout de secours. trigger.click()
    // ouvre via /open (idempotent). Différé pour ne pas être annulé par le morph.
    let opened = false;
    const openDrawer = () => {
      if (opened) return;
      opened = true;
      document.removeEventListener('argile:recos-ready', openDrawer);
      btn.classList.remove('is-loading'); // fin du spinner : le tiroir s'ouvre maintenant
      // API publique du composant Horizon (cart-drawer.js → open()/showDialog()) :
      // plus robuste qu'un clic synthétique routé via la commande `/open`.
      const cd = document.querySelector('cart-drawer-component');
      if (cd && typeof cd.open === 'function') {
        cd.open();
        return;
      }
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) trigger.click();
    };

    try {
      const res = await (
        await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1, sections: sectionIds.join(',') }),
        })
      ).json();
      const cart = await (await fetch('/cart.js')).json();

      // Ouverture différée : après le morph + le (re)chargement du cross-sell.
      document.addEventListener('argile:recos-ready', openDrawer);
      setTimeout(openDrawer, 1200);

      // Event natif Horizon : on fournit les sections rendues pour un morph
      // sans re-fetch du tiroir, et on déclenche le rechargement du cross-sell.
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'argile-collection-shop',
            data: {
              source: 'argile-collection-shop',
              itemCount: cart.item_count,
              sections: res.sections,
            },
          },
        })
      );
    } catch (e) {
      console.error('[argile-shop] add to cart failed', e);
      openDrawer();
    } finally {
      delete btn.dataset.loading;
    }
  });
})();
